import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translation_ja from './ja.json'
import translation_en from './en.json'
import translation_ko from './ko.json'

export type AppLanguage = 'ja' | 'en' | 'ko'

export const supported_languages = ['ja', 'en', 'ko'] as const

export const normalizeLanguage = (language: string | null | undefined): AppLanguage | null => {
  if (!language) return null
  const normalized_language = language.split('-')[0]
  return supported_languages.includes(normalized_language as AppLanguage)
    ? normalized_language as AppLanguage
    : null
}

// LocalStorageに保存された言語設定があればそれを使用、なければブラウザの言語設定を使用
const saved_language = normalizeLanguage(localStorage.getItem('language'))
const browser_language = normalizeLanguage(navigator.language)
const default_language = saved_language || browser_language || 'ja'

i18n
.use(initReactI18next)
.init({
  resources: {
    ja: {translation: translation_ja},
    en: {translation: translation_en},
    ko: {translation: translation_ko}
  },
  supportedLngs: supported_languages,
  load: 'languageOnly',
  nonExplicitSupportedLngs: true,
  lng: default_language,
  fallbackLng: (code) => {
    const language = normalizeLanguage(code)
    if (language === 'ko') return ['en', 'ja']
    if (language === 'en') return ['ja']
    return ['en']
  },
  interpolation: {
    escapeValue: false
  }
})

export default i18n
